<app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

  <!-- File input nascosto -->
  <input
    type="file"
    #fileInput
    style="display: none"
    (change)="onFileSelected($event)"
    accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
  />

  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mt-3 ms-1 mb-3 w-100">
    <h3 class="m-0">Documenti</h3>

    <div class="hidden-mobile">
      <button
        mat-stroked-button
        type="button"
        (click)="triggerFileUpload()"
        [disabled]="isUploading"
        matTooltip="Carica un nuovo documento"
        class="attachment-button"
      >
        <mat-icon>upload_file</mat-icon>
        {{ isUploading ? 'Caricamento...' : 'Carica documento' }}
      </button>
    </div>
  </div>

  <!-- Mobile: pulsante full-width -->
  <div class="visible-mobile mt-2 w-100 mb-3">
    <button
      mat-stroked-button
      type="button"
      (click)="triggerFileUpload()"
      [disabled]="isUploading"
      class="w-100 attachment-button"
    >
      <mat-icon>upload_file</mat-icon>
      {{ isUploading ? 'Caricamento...' : 'Carica documento' }}
    </button>
  </div>

  <!-- Loading State -->
  <ng-container *ngIf="isLoading; else contentTemplate">
    <div class="loading-container d-flex flex-column justify-content-center align-items-center py-5">
      <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
      <p class="mt-3">Caricamento in corso...</p>
    </div>
  </ng-container>

  <!-- Content Template -->
  <ng-template #contentTemplate>
    <!-- No Documents State -->
    <ng-container
      *ngIf="documentGroups.length === 0; else documentsTemplate">
      <div class="d-flex flex-column justify-content-center align-items-center py-5">
        <!-- <img mat-card-image class="col-md-3 col-9 mb-4" src="izy_image_2.png" alt="Nessun documento"> -->
        <mat-icon class="empty-icon mb-3">no_sim</mat-icon>
        <h5 class="mb-3">Nessun documento da mostrare qui...</h5>
        <div class="d-flex flex-column justify-content-center align-items-center">
          <p class="text-mutedr">Non ci sono documenti caricati per questa organizzazione.</p>
        </div>
        </div>
    </ng-container>

    <!-- Documents grouped by category -->
    <ng-template #documentsTemplate>
      <!-- Filter chips per category -->
      <div class="mb-2" *ngIf="categoryFilterOptions.length > 1">
        <mat-chip-listbox
          aria-label="Filtra per tipologia di documento"
          [value]="selectedCategory"
          (change)="applyCategoryFilter($event.value)"
          hideSingleSelectionIndicator
        >
          <mat-chip-option
            *ngFor="let option of categoryFilterOptions; trackBy: trackByFilterValue"
            [value]="option.value"
            [selectable]="true"
            [matTooltip]="'Mostra solo: ' + option.name"
          >
            {{ option.name }}
          </mat-chip-option>
        </mat-chip-listbox>
      </div>

      <!-- Section per category -->
      <ng-container *ngFor="let group of documentGroups; trackBy: trackByCategory">
        <h5 class="ms-2 mt-3 mb-3">{{ group.label }}</h5>

        <div *ngFor="let document of group.documents" class="document-item">
          <mat-card class="contract-card mb-1">
            <mat-card-content class="m-0">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="mb-1 d-flex align-items-center flex-wrap">
                    <span class="me-2">{{ document.name }}</span>
                    <span
                      *ngIf="document.is_uploaded_by_user"
                      class="uploaded-badge"
                    >
                      <mat-icon class="badge-icon">person</mat-icon>
                      Caricato da te
                    </span>
                  </h6>
                  <p class="text-muted mb-0 small">
                    <mat-icon class="me-1" style="vertical-align: middle; font-size: 16px;">
                      {{ group.icon }}
                    </mat-icon>
                    {{ group.label }}
                  </p>
                </div>

                <button
                  *ngIf="document.file"
                  mat-stroked-button
                  color="primary"
                  (click)="openAttachment(document.file)"
                  class="ms-2 hidden-mobile attachment-button"
                >
                  <mat-icon>visibility</mat-icon>
                  Visualizza
                </button>
                <!-- mobile version  -->
                <button
                  *ngIf="document.file"
                  mat-stroked-button
                  color="primary"
                  (click)="openAttachment(document.file)"
                  class="m-0 align-items-center text-center visible-mobile attachment-button"
                >
                  <mat-icon class="ms-2">visibility</mat-icon>
                </button>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </ng-container>

      <!-- TODO: Payment Section -->
      <!-- <ng-container>
          <h5 class="ms-2 mt-3 mb-3">Pagamenti</h5>
          
          <mat-card class="contract-card">
            <mat-card-content>
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="mb-1">Pagamento effettuato</h6>
                  <p class="text-muted mb-0 small">
                    <mat-icon class="me-1" style="vertical-align: middle; font-size: 16px;">
                      attach_money
                    </mat-icon>
                    RIcevuta pagamento
                  </p>
                </div>
                
                <button 
                  *ngIf="payment_data?.attached_receipt"
                  mat-stroked-button 
                  color="primary"
                  (click)="openAttachment(payment_data?.attached_receipt!)"
                  class="ms-2 hidden-mobile attachment-button"
                >
                  <mat-icon>visibility</mat-icon>
                  Scarica contratto
                </button>
                <button 
                  *ngIf="payment_data?.attached_receipt"
                  mat-stroked-button 
                  color="primary"
                  (click)="openAttachment(payment_data?.attached_receipt!)"
                  class="m-0 align-items-center text-center visible-mobile attachment-button"
                >
                  <mat-icon class="ms-2">visibility</mat-icon>
                </button>
              </div>
            </mat-card-content>
          </mat-card>
      </ng-container> -->

    </ng-template>
  </ng-template>
